



































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import Drawer from '@/components/Drawer.vue';
import SearchBar from '@/components/SearchBar.vue';
import ApplicationsList from '@/components/ApplicationsList.vue';
import ApplicationEdit from '@/components/ApplicationEdit.vue';
import { Action, Getter } from 'vuex-class';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    SearchBar,
    Drawer,
    ApplicationsList,
    ApplicationEdit,
  },
})
export default class Applications extends Vue {

  public application: any = null;
  private showAddEditApplicationDialog: boolean = false;
  private searchNames: string = '';
  private saved: boolean = false;
  private isSaving: boolean = false;
  @Action private editApplicationsAsync: any;
  @Getter private hasPermission: any;

  public mounted() {
    if (!this.hasPermission('administration:view')) {
      this.$router.push('/');
    }
  }

  private async editApplication(app: any) {
    this.application = app && app.id > 0 ? app : {name: '', organisations: [], type: ''};
    this.showAddEditApplicationDialog = true;
  }

  private async saveApplication() {
    await (this.$refs.addEditForm as ApplicationEdit).save();

    this.saved = false;
    this.isSaving = false;
  }

  private async close() {
    this.showAddEditApplicationDialog = false;

    await (this.$refs.appList as ApplicationsList).loadApplications();

  }
}
